"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertComponent = void 0;
exports.ProgressBar = ProgressBar;
exports.SpinnerBootstrap = SpinnerBootstrap;
exports.SuccessToast = SuccessToast;
exports.GDFolderIconLink = GDFolderIconLink;
exports.CopyIconLink = CopyIconLink;
exports.MenuIconLink = MenuIconLink;
exports.GDDocFileIconLink = GDDocFileIconLink;
exports.EditIconButton = EditIconButton;
exports.DeleteIconButton = DeleteIconButton;
exports.CopyIconButton = CopyIconButton;
exports.ReplyIconButton = ReplyIconButton;
exports.PdfIconButton = PdfIconButton;
exports.SignedPdfIconButton = SignedPdfIconButton;
exports.UploadSignedPdfIconButton = UploadSignedPdfIconButton;
exports.CaseListIconButton = CaseListIconButton;
exports.PermissionsIconButton = PermissionsIconButton;
exports.MenuExpandIconButton = MenuExpandIconButton;
exports.MapIconButton = MapIconButton;
exports.InvoiceStatusBadge = InvoiceStatusBadge;
exports.KsefStatusBadge = KsefStatusBadge;
exports.FidmanSyncBadge = FidmanSyncBadge;
exports.ContractTypeBadge = ContractTypeBadge;
exports.ContractStatusBadge = ContractStatusBadge;
exports.MilestoneStatusBadge = MilestoneStatusBadge;
exports.CaseStatusBadge = CaseStatusBadge;
exports.SecurityStatusBadge = SecurityStatusBadge;
exports.OfferStatusBadge = OfferStatusBadge;
exports.OfferBondStatusBadge = OfferBondStatusBadge;
exports.OfferInvitationMailStatusBadge = OfferInvitationMailStatusBadge;
exports.TaskStatusBadge = TaskStatusBadge;
exports.ApplicationCallStatusBadge = ApplicationCallStatusBadge;
exports.ClientNeedStatusBadge = ClientNeedStatusBadge;
exports.MyTooltip = MyTooltip;
exports.DaysLeftBadge = DaysLeftBadge;
exports.LetterStatusBadge = LetterStatusBadge;
const react_1 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const react_bootstrap_1 = require("react-bootstrap");
require("react-bootstrap-typeahead/css/Typeahead.css");
const Google_Drive_icon_png_1 = __importDefault(require("../../Resources/View/Google-Drive-icon.png"));
const Google_Docs_icon_png_1 = __importDefault(require("../../Resources/View/Google-Docs-icon.png"));
require("../../Css/styles.css");
const MainSetupReact_1 = __importDefault(require("../../React/MainSetupReact"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
function ProgressBar() {
    return react_1.default.createElement("progress", { style: { height: "5px" } });
}
function SpinnerBootstrap() {
    return react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", variant: "success" });
}
const AlertComponent = ({ message, type, timeout = 3000 }) => {
    const [show, setShow] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        const timer = setTimeout(() => {
            setShow(false);
        }, timeout);
        return () => {
            clearTimeout(timer);
        };
    }, [timeout]);
    if (!show) {
        return null;
    }
    return (react_1.default.createElement(react_bootstrap_1.Alert, { variant: type, onClose: () => setShow(false), dismissible: true }, message));
};
exports.AlertComponent = AlertComponent;
function SuccessToast({ header = "Sukces", message, show, onClose, bg }) {
    if (typeof document === "undefined")
        return null;
    // Portal do body + pozycja fixed bottom-end — inaczej wewnątrz modala toast
    // pozycjonuje się względem modala (ląduje na środku ekranu), nie viewportu.
    return (0, react_dom_1.createPortal)(react_1.default.createElement(react_bootstrap_1.ToastContainer, { position: "bottom-end", className: "p-3", style: { position: "fixed", zIndex: 9999 } },
        react_1.default.createElement(react_bootstrap_1.Toast, { onClose: onClose, show: show, delay: 5000, autohide: true, bg: bg },
            react_1.default.createElement(react_bootstrap_1.Toast.Header, null,
                react_1.default.createElement("strong", { className: "me-auto" }, header)),
            react_1.default.createElement(react_bootstrap_1.Toast.Body, { className: bg === "danger" ? "text-white" : undefined }, message))), document.body);
}
function GDFolderIconLink({ folderUrl, layout = "vertical" }) {
    const className = layout === "vertical" ? "icon icon-vertical" : "icon icon-horizontal";
    return (react_1.default.createElement("a", { href: folderUrl, target: "_blank", rel: "noopener noreferrer" },
        react_1.default.createElement("img", { src: Google_Drive_icon_png_1.default, alt: "Dysk Google", className: className })));
}
function CopyIconLink({ folderUrl, layout = "vertical" }) {
    const className = layout === "vertical" ? "icon icon-vertical" : "icon icon-horizontal";
    return (react_1.default.createElement("a", { href: folderUrl, target: "_blank", rel: "noopener noreferrer" },
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCopy, className: className })));
}
function MenuIconLink({ folderUrl, layout = "vertical" }) {
    const className = layout === "vertical" ? "icon icon-vertical" : "icon icon-horizontal";
    return (react_1.default.createElement("a", { href: folderUrl, target: "_blank", rel: "noopener noreferrer" },
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faBars, className: className })));
}
function GDDocFileIconLink({ folderUrl, layout = "vertical" }) {
    const className = layout === "vertical" ? "icon icon-vertical" : "icon icon-horizontal";
    return (react_1.default.createElement("a", { href: folderUrl, target: "_blank" },
        react_1.default.createElement("img", { src: Google_Docs_icon_png_1.default, alt: "Dysk Google", className: className })));
}
function IconButton({ icon, layout, onClick, className, title }) {
    className += layout === "vertical" ? " icon icon-vertical" : " icon icon-horizontal";
    return (react_1.default.createElement("span", { onClick: (e) => {
            e.preventDefault();
            onClick();
        }, className: `${className}`, style: { cursor: "pointer" }, title: title, "aria-label": title },
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: icon, size: "lg" })));
}
function EditIconButton({ layout, onClick }) {
    return react_1.default.createElement(IconButton, { icon: free_solid_svg_icons_1.faPencil, layout: layout, onClick: onClick, className: "text-primary" });
}
function DeleteIconButton({ layout, onClick }) {
    return react_1.default.createElement(IconButton, { icon: free_solid_svg_icons_1.faTrash, layout: layout, onClick: onClick, className: "text-danger" });
}
function CopyIconButton({ layout, onClick }) {
    return react_1.default.createElement(IconButton, { icon: free_solid_svg_icons_1.faCopy, layout: layout, onClick: onClick, className: "text-info" });
}
function ReplyIconButton({ layout, onClick }) {
    return react_1.default.createElement(IconButton, { icon: free_solid_svg_icons_1.faReply, layout: layout, onClick: onClick, className: "text-success" });
}
function PdfIconButton({ layout, onClick }) {
    return react_1.default.createElement(IconButton, { icon: free_solid_svg_icons_1.faFilePdf, layout: layout, onClick: onClick, className: "text-danger" });
}
/** PDF pisma z podpisem kwalifikowanym (okno podpisu) */
function SignedPdfIconButton({ layout, onClick }) {
    return (react_1.default.createElement(IconButton, { icon: free_solid_svg_icons_1.faFileSignature, layout: layout, onClick: onClick, className: "text-success", title: "PDF z podpisem kwalifikowanym" }));
}
/** Wgranie PDF-a podpisanego poza PS (okno „Wgraj podpisany”) */
function UploadSignedPdfIconButton({ layout, onClick }) {
    return (react_1.default.createElement(IconButton, { icon: free_solid_svg_icons_1.faFileArrowUp, layout: layout, onClick: onClick, className: "text-primary", title: "Wgraj podpisany PDF" }));
}
/** Generowanie spisu spraw kontraktu (arkusz Google) */
function CaseListIconButton({ layout, onClick }) {
    return react_1.default.createElement(IconButton, { icon: free_solid_svg_icons_1.faListCheck, layout: layout, onClick: onClick, className: "text-success" });
}
/** Przejście z osoby do jej konta i uprawnień (okno „Personel i uprawnienia”) */
function PermissionsIconButton({ layout, onClick }) {
    return react_1.default.createElement(IconButton, { icon: free_solid_svg_icons_1.faUserShield, layout: layout, onClick: onClick, className: "text-success" });
}
function MenuExpandIconButton({ layout, onClick }) {
    const icon = layout === "vertical" ? free_solid_svg_icons_1.faEllipsisV : free_solid_svg_icons_1.faEllipsisH;
    return react_1.default.createElement(IconButton, { icon: icon, layout: layout, onClick: onClick, className: "text-secondary" });
}
function MapIconButton({ layout, onClick }) {
    return react_1.default.createElement(IconButton, { icon: free_solid_svg_icons_1.faLocationDot, layout: layout, onClick: onClick, className: "text-danger" });
}
function InvoiceStatusBadge({ status }) {
    let variant;
    let textMode = "light";
    switch (status) {
        case MainSetupReact_1.default.InvoiceStatuses.FOR_LATER:
            variant = "light";
            textMode = "dark";
            break;
        case MainSetupReact_1.default.InvoiceStatuses.TO_DO:
            variant = "primary";
            break;
        case MainSetupReact_1.default.InvoiceStatuses.DONE:
            variant = "warning";
            textMode = "dark";
            break;
        case MainSetupReact_1.default.InvoiceStatuses.SENT:
            variant = "info";
            break;
        case MainSetupReact_1.default.InvoiceStatuses.READY_FOR_KSEF:
            variant = "primary";
            break;
        case MainSetupReact_1.default.InvoiceStatuses.SENT_TO_KSEF:
            variant = "success";
            break;
        case MainSetupReact_1.default.InvoiceStatuses.KSEF_ERROR:
            variant = "danger";
            break;
        case MainSetupReact_1.default.InvoiceStatuses.PAID:
            variant = "success";
            break;
        case MainSetupReact_1.default.InvoiceStatuses.TO_CORRECT:
            variant = "danger";
            break;
        case MainSetupReact_1.default.InvoiceStatuses.WITHDRAWN:
            variant = "dark";
            break;
        case MainSetupReact_1.default.InvoiceStatuses.CORRECTED:
            variant = "warning";
            textMode = "dark";
            break;
        default:
            variant = "secondary";
    }
    return (react_1.default.createElement(react_bootstrap_1.Badge, { bg: variant, text: textMode }, status));
}
function KsefStatusBadge({ ksefNumber, ksefStatus, }) {
    if (ksefNumber) {
        return (react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "top", overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: "ksef-tooltip" }, ksefNumber) },
            react_1.default.createElement(react_bootstrap_1.Badge, { bg: "success", text: "light" }, "\u2705 Przyj\u0119ta")));
    }
    if (ksefStatus === "PENDING") {
        return (react_1.default.createElement(react_bootstrap_1.Badge, { bg: "warning", text: "dark" }, "\uD83D\uDFE1 Wys\u0142ana"));
    }
    return null;
}
/**
 * SYNC-P2 — FIDman outbox status badge for a contract (see
 * ../../Contracts/ContractsList/Modals/fidmanSyncService.ts). "NONE" (never
 * enqueued, e.g. non-synced contract type) renders nothing.
 */
function FidmanSyncBadge({ status, tooltip, }) {
    if (!status || status === "NONE")
        return null;
    const byStatus = {
        SENT: { bg: "success", text: "light", label: "✅ FIDman: zsynchronizowano" },
        PENDING: { bg: "secondary", text: "light", label: "⏳ FIDman: w trakcie" },
        FAILED: { bg: "danger", text: "light", label: "⚠️ FIDman: synchronizacja do dopchnięcia" },
        SKIPPED: { bg: "warning", text: "dark", label: "🟡 FIDman: brakujące dane" },
    };
    const { bg, text, label } = byStatus[status];
    const badge = (react_1.default.createElement(react_bootstrap_1.Badge, { bg: bg, text: text }, label));
    if (!tooltip)
        return badge;
    return (react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "top", overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: "fidman-sync-tooltip" }, tooltip) }, badge));
}
/**
 * Badge typu kontraktu z akcentem odstępstwa od typowego rozliczenia (kanon firmowy
 * 40_wiki/firma/technologie/plakietka-typu-kontraktu-akcent, decyzja FID.APP.01
 * 2026-07-28 — zastępuje odrzucone dwubarwne tło z twardym cięciem 77%).
 * Baza = kolor osi FIDIC (pierwsze słowo nazwy: „Czerwony" → czerwień, „Żółty" → żółć);
 * akcent = kolor metody rozliczenia, gdy niedomyślna wobec `settlementMethod` (RZL-3,
 * osobna kolumna `Contracts.SettlementMethod` — 40_wiki/firma/technologie/
 * plakietka-typu-kontraktu-akcent#implementacja): „Czerwony" + `LUMP_SUM` → akcent
 * żółty, „Żółty" + `MEASUREMENT` → akcent czerwony. Każda inna kombinacja, w tym
 * `null`/brak wartości i typy spoza osi FIDIC — bez akcentu. Odstępstwo NIE jest już
 * czytane z drugiego słowa nazwy typu (to był model sprzed RZL, `TypeId` w tym pakcie
 * pozostaje nietknięty). Tekst w badge = JEDNO słowo (pierwsze); pełna nazwa w tooltipie
 * (gdy nazwa typu ma więcej niż jedno słowo), sam akcent dodatkowo opisany dla czytnika
 * ekranu. Typy spoza osi FIDIC (IK, PT, AQM…) → neutralny badge, nigdy z akcentem.
 *
 * NIE ZMIENIAĆ bez nowej decyzji ownera (kontrast WCAG AA):
 * - kierunek `to left` — zapis procentowy od lewej wygasza w innym miejscu dla „Czerwony"
 *   i „Żółty" (różna długość słowa), ostatnie litery siadają wtedy na mieszance kolorów;
 * - `transparent 1.45em` i `paddingRight: 1.6em` są SPAROWANE — zmiana jednej wymaga
 *   przeliczenia drugiej;
 * - odcinek pełnego nasycenia `0 .45em` — bez niego akcent przestaje dawać się nazwać
 *   kolorem i jest najsłabszy przy daltonizmie.
 */
function ContractTypeBadge({ type, settlementMethod, }) {
    const name = (type?.name ?? "").trim();
    if (!name)
        return null;
    const RED = "#dc3545";
    const YELLOW = "#ffc107";
    const words = name.split(/\s+/);
    const first = words[0];
    const hasModifier = words.length > 1; // tylko do decyzji o tooltipie z pełną nazwą
    const base = first === "Czerwony" ? RED : first === "Żółty" ? YELLOW : null;
    const stripe = base === RED ? YELLOW : base === YELLOW ? RED : null;
    const isDark = base === YELLOW; // żółte tło → ciemny tekst
    // Reguła odstępstwa (kontrakt danych RZL): źródło = settlementMethod, nie nazwa typu.
    const hasAccent = (base === RED && settlementMethod === "LUMP_SUM") || (base === YELLOW && settlementMethod === "MEASUREMENT");
    const style = base
        ? {
            backgroundColor: base,
            backgroundImage: hasAccent
                ? `linear-gradient(to left, ${stripe} 0 .45em, transparent 1.45em)`
                : undefined,
            color: isDark ? "#212529" : "#fff",
            paddingRight: hasAccent ? "1.6em" : undefined, // tekst nie wchodzi na akcent
        }
        : {};
    // akcent jest wyłącznie wizualny — czytnik ekranu dostaje go słowem
    const accentLabel = hasAccent ? (react_1.default.createElement("span", { className: "visually-hidden" }, settlementMethod === "LUMP_SUM" ? " — rozliczany ryczałtem" : " — rozliczany obmiarem")) : null;
    const badge = base ? (
    // bg="" wyłącza domyślne `bg-primary` — Bootstrap daje mu `!important`, więc bez tego
    // inline `backgroundColor` nie wchodzi w życie i baza zostaje niebieska (błąd z TY-1)
    react_1.default.createElement(react_bootstrap_1.Badge, { bg: "", style: style },
        first,
        accentLabel)) : (react_1.default.createElement(react_bootstrap_1.Badge, { bg: "secondary", text: "light" }, first));
    if (!hasModifier)
        return badge;
    return (react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "top", overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: "contract-type-tooltip" }, name) }, badge));
}
function ContractStatusBadge({ status, className, style, }) {
    let variant;
    let textMode = "light";
    switch (status) {
        case MainSetupReact_1.default.ContractStatuses.NOT_STARTED:
            variant = "secondary";
            break;
        case MainSetupReact_1.default.ContractStatuses.IN_PROGRESS:
            variant = "warning";
            textMode = "dark";
            break;
        case MainSetupReact_1.default.ContractStatuses.FINISHED:
            variant = "success";
            break;
        case MainSetupReact_1.default.ContractStatuses.ARCHIVAL:
            variant = "dark";
            break;
        default:
            variant = "secondary";
    }
    return (react_1.default.createElement(react_bootstrap_1.Badge, { bg: variant, text: textMode, className: className, style: style }, status));
}
function MilestoneStatusBadge({ status }) {
    let variant;
    let textMode = "light";
    switch (status) {
        case MainSetupReact_1.default.MilestoneStatus.NOT_STARTED:
            variant = "secondary";
            break;
        case MainSetupReact_1.default.MilestoneStatus.IN_PROGRESS:
            variant = "warning";
            textMode = "dark";
            break;
        case MainSetupReact_1.default.MilestoneStatus.FINISHED:
            variant = "success";
            break;
        case MainSetupReact_1.default.MilestoneStatus.ARCHIVAL:
            variant = "dark";
            break;
        default:
            variant = "secondary";
    }
    return (react_1.default.createElement(react_bootstrap_1.Badge, { bg: variant, text: textMode }, status));
}
function CaseStatusBadge({ status }) {
    let variant;
    let textMode = "light";
    switch (status) {
        case MainSetupReact_1.default.CaseStatus.FOR_LATER:
            variant = "secondary";
            break;
        case MainSetupReact_1.default.CaseStatus.IN_PROGRESS:
            variant = "warning";
            textMode = "dark";
            break;
        case MainSetupReact_1.default.CaseStatus.CLOSED:
            variant = "success";
            break;
        default:
            variant = "secondary";
    }
    return (react_1.default.createElement(react_bootstrap_1.Badge, { bg: variant, text: textMode }, status));
}
function SecurityStatusBadge({ status }) {
    let variant;
    let textMode = "light";
    switch (status) {
        case MainSetupReact_1.default.SecurityStatus.NOT_ISSUED:
            variant = "secondary";
            break;
        case MainSetupReact_1.default.SecurityStatus.ISSUED:
            variant = "warning";
            textMode = "dark";
            break;
        case MainSetupReact_1.default.SecurityStatus.TO_PROLONG:
            variant = "danger";
            break;
        case MainSetupReact_1.default.SecurityStatus.PROLONGED:
            variant = "success";
            break;
        case MainSetupReact_1.default.SecurityStatus.RETURNED_1ST_PART:
            variant = "info";
            break;
        case MainSetupReact_1.default.SecurityStatus.RETURNED_2ND_PART:
            variant = "success";
            break;
        default:
            variant = "secondary";
    }
    return (react_1.default.createElement(react_bootstrap_1.Badge, { bg: variant, text: textMode }, status));
}
function OfferStatusBadge({ status }) {
    let variant;
    let textMode = "light";
    switch (status) {
        //DECISION_PENDING: 'Składamy czy nie?',
        case MainSetupReact_1.default.OfferStatus.DECISION_PENDING:
            variant = "warning";
            textMode = "dark";
            break;
        case MainSetupReact_1.default.OfferStatus.TO_DO:
            variant = "primary";
            break;
        case MainSetupReact_1.default.OfferStatus.DONE:
            variant = "info";
            break;
        case MainSetupReact_1.default.OfferStatus.AWARDED:
            variant = "success";
            break;
        case MainSetupReact_1.default.OfferStatus.LOST:
            variant = "secondary";
            break;
        case MainSetupReact_1.default.OfferStatus.WITHDRAWN:
            variant = "warning";
            textMode = "dark";
            break;
        case MainSetupReact_1.default.OfferStatus.NOT_INTERESTED:
            variant = "secondary";
            break;
        case MainSetupReact_1.default.OfferStatus.CANCELED:
            variant = "danger";
            break;
        default:
            variant = "light";
            textMode = "dark";
    }
    return (react_1.default.createElement(react_bootstrap_1.Badge, { bg: variant, text: textMode }, status));
}
function OfferBondStatusBadge({ status }) {
    let variant;
    let textMode = "light";
    switch (status) {
        case MainSetupReact_1.default.OfferBondStatus.TO_PAY:
            variant = "primary";
            break;
        case MainSetupReact_1.default.OfferBondStatus.PAID:
            variant = "light";
            textMode = "success";
            break;
        case MainSetupReact_1.default.OfferBondStatus.DONE:
            variant = "info";
            break;
        case MainSetupReact_1.default.OfferBondStatus.TO_RENEW:
            variant = "danger";
            break;
        case MainSetupReact_1.default.OfferBondStatus.TO_BE_RETURNED:
            variant = "warning";
            break;
        case MainSetupReact_1.default.OfferBondStatus.RETURNED:
            variant = "success";
            break;
        default:
            variant = "light";
            textMode = "dark";
    }
    return (react_1.default.createElement(react_bootstrap_1.Badge, { bg: variant, text: textMode }, status));
}
function OfferInvitationMailStatusBadge({ status }) {
    let variant;
    let textMode = "light";
    switch (status) {
        case MainSetupReact_1.default.OfferInvitationMailStatus.NEW:
            variant = "warning";
            textMode = "dark";
            break;
        case MainSetupReact_1.default.OfferInvitationMailStatus.TO_OFFER:
            variant = "danger";
            break;
        case MainSetupReact_1.default.OfferInvitationMailStatus.DONE:
            variant = "success";
            break;
        case MainSetupReact_1.default.OfferInvitationMailStatus.REJECTED:
            variant = "secondary";
            break;
        default:
            variant = "light";
            textMode = "dark";
    }
    return (react_1.default.createElement(react_bootstrap_1.Badge, { bg: variant, text: textMode }, status));
}
function TaskStatusBadge({ status }) {
    let variant;
    let textMode = "light";
    switch (status) {
        case MainSetupReact_1.default.TaskStatus.BACKLOG:
            variant = "light";
            textMode = "dark";
            break;
        case MainSetupReact_1.default.TaskStatus.NOT_STARTED:
            variant = "secondary";
            break;
        case MainSetupReact_1.default.TaskStatus.IN_PROGRESS:
            variant = "warning";
            textMode = "dark";
            break;
        case MainSetupReact_1.default.TaskStatus.TO_CORRECT:
            variant = "danger";
            break;
        case MainSetupReact_1.default.TaskStatus.AWAITING_RESPONSE:
            variant = "info";
            break;
        case MainSetupReact_1.default.TaskStatus.DONE:
            variant = "success";
            break;
        default:
            variant = "secondary";
    }
    return (react_1.default.createElement(react_bootstrap_1.Badge, { bg: variant, text: textMode }, status));
}
function ApplicationCallStatusBadge({ status }) {
    let variant;
    let textMode = "light";
    switch (status) {
        case MainSetupReact_1.default.ApplicationCallStatus.CLOSED:
            variant = "secondary";
            break;
        case MainSetupReact_1.default.ApplicationCallStatus.OPEN:
            variant = "danger";
            break;
        case MainSetupReact_1.default.ApplicationCallStatus.SCHEDULED:
            variant = "warning";
            textMode = "dark";
            break;
        case MainSetupReact_1.default.ApplicationCallStatus.UNKOWN:
            variant = "light";
            textMode = "dark";
            break;
        default:
            variant = "secondary";
    }
    return (react_1.default.createElement(react_bootstrap_1.Badge, { bg: variant, text: textMode }, status));
}
function ClientNeedStatusBadge({ status }) {
    let variant;
    let textMode = "light"; // Default text mode to light for better contrast on darker badges
    // Determine badge color and text color based on the status
    switch (status) {
        case MainSetupReact_1.default.ClientNeedStatus.URGENT:
            variant = "danger"; // Red indicates urgency
            break;
        case MainSetupReact_1.default.ClientNeedStatus.IMPORTANT:
            variant = "warning"; // Orange indicates importance
            textMode = "dark";
            break;
        case MainSetupReact_1.default.ClientNeedStatus.NICE_TO_HAVE:
            variant = "info"; // Blue indicates a nice to have but not critical
            break;
        case MainSetupReact_1.default.ClientNeedStatus.FOR_LATER:
            variant = "secondary"; // Grey indicates low priority
            break;
        case MainSetupReact_1.default.ClientNeedStatus.NOT_ACTUAL:
            variant = "dark"; // Dark to signify it's no longer relevant
            textMode = "light";
            break;
        default:
            variant = "light"; // Light for unknown or default status
            textMode = "dark";
            break;
    }
    // Return the Badge component with the appropriate styling
    return (react_1.default.createElement(react_bootstrap_1.Badge, { bg: variant, text: textMode }, status));
}
function MyTooltip({ children, content: tooltipContent, placement = "right", ...rest }) {
    return (react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: placement, delay: { show: 250, hide: 400 }, overlay: (props) => (react_1.default.createElement(react_bootstrap_1.Tooltip, { id: "button-tooltip", ...props }, tooltipContent)), ...rest }, children));
}
function DaysLeftBadge({ daysLeft }) {
    let variant;
    let textMode = "light";
    if (daysLeft < 10) {
        variant = "danger";
    }
    else if (daysLeft < 20) {
        variant = "warning";
        textMode = "dark";
    }
    else {
        variant = "success";
    }
    return (react_1.default.createElement(react_bootstrap_1.Badge, { bg: variant, text: textMode },
        daysLeft,
        " dni"));
}
function LetterStatusBadge({ status }) {
    let variant;
    let textMode = "light";
    switch (status) {
        case MainSetupReact_1.default.OurLetterStatus.CREATED:
            variant = "secondary";
            break;
        case MainSetupReact_1.default.OurLetterStatus.TO_CORRECT:
            variant = "warning";
            textMode = "dark";
            break;
        case MainSetupReact_1.default.OurLetterStatus.CHANGED:
            variant = "info";
            break;
        case MainSetupReact_1.default.OurLetterStatus.APPROVED:
            variant = "success";
            break;
        case MainSetupReact_1.default.OurLetterStatus.SENT:
            variant = "primary";
            break;
        case MainSetupReact_1.default.IncomingLetterStatus.REGISTERED:
            variant = "secondary";
            break;
        case MainSetupReact_1.default.IncomingLetterStatus.RESPONSE_SENT:
            variant = "success";
            break;
        case MainSetupReact_1.default.IncomingLetterStatus.RESPONSE_REQUIRED:
            variant = "danger";
            break;
        case MainSetupReact_1.default.IncomingLetterStatus.NO_RESPONSE_REQUIRED:
            variant = "info";
            break;
        default:
            variant = "light";
            textMode = "dark";
            break;
    }
    return (react_1.default.createElement(react_bootstrap_1.Badge, { bg: variant, text: textMode }, status));
}
